import { render, staticRenderFns } from "./DownloadView.vue?vue&type=template&id=b0afb932&scoped=true"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"
import style0 from "./DownloadView.vue?vue&type=style&index=0&id=b0afb932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0afb932",
  null
  
)

export default component.exports